export default {
  edit: { id: 'edit' },
  title: { id: 'title' },
  dateUpdated: { id: 'date_updated' },
  saveInfo: { id: 'save_info' },
  jobWorkflowInputTranslation: { id: 'job_workflow_input_translation' },
  jobWorkflowInputList: { id: 'job_workflow_input_list' },
  options: { id: 'options' },
  images: { id: 'images' },
  constantValue: { id: 'constant_value' },
  unit: { id: 'unit' },
}
